import { render, staticRenderFns } from "./SignDocumentModal.vue?vue&type=template&id=481aa83a&scoped=true&"
import script from "./SignDocumentModal.vue?vue&type=script&lang=js&"
export * from "./SignDocumentModal.vue?vue&type=script&lang=js&"
import style0 from "./SignDocumentModal.vue?vue&type=style&index=0&id=481aa83a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481aa83a",
  null
  
)

export default component.exports